import { Link } from 'react-router-dom';

const SERVICE_LINKS = [
  { label: 'Office Cleaning', href: '/services/office-cleaning' },
  { label: 'Janitorial Services', href: '/services/office-cleaning' },
  { label: 'Floor Care & Maintenance', href: '/services/office-cleaning' },
  { label: 'Carpet Cleaning', href: '/services/office-cleaning' },
  { label: 'Restroom Sanitation', href: '/services/office-cleaning' },
  { label: 'Post-Construction Cleaning', href: '/services/office-cleaning' },
];

const COMPANY_LINKS = [
  { label: 'About Us', href: '/about' },
  { label: 'Service Areas', href: '/locations/metairie-la' },
  { label: 'Contact Us', href: '/contact' },
  { label: 'Get a Free Quote', href: '/contact' },
];

const CERTIFICATIONS = [
  'GSA Schedule Contractor #47QSHA22D0020',
  'MBE, 8a Graduated, DBE, HUD Section 3',
  'GBAC Certified on SARS-CoV-2/COVID-19',
  'LA Contractor License #71638',
];

export default function Footer() {
  return (
    <footer className="bg-navy-light border-t border-navy-border">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src="https://ojsjanitorial.net/wp-content/uploads/2023/04/logo.png"
                alt="OJ's Janitorial & Sweeping Service, LLC"
                className="h-14 w-auto object-contain"
              />
              <div>
                <div className="text-white font-heading font-bold text-sm leading-tight">OJ's Janitorial</div>
                <div className="text-accent text-xs font-body">& Sweeping Service, LLC</div>
              </div>
            </Link>
            <p className="text-white/50 text-sm font-body leading-relaxed mb-6">
              Professional commercial cleaning services for offices, buildings, and facilities across Metairie and the Greater New Orleans area.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.bbb.org/us/la/metairie/profile/cleaning-services/ojs-janitorial-sweeping-service-llc-0985-90015985/"
                target="_blank"
                rel="nofollow noopener"
                className="cursor-pointer"
              >
                <img
                  src="https://seal-neworleans.bbb.org/seals/blue-seal-150-110-bbb-90015985.png"
                  alt="BBB Accredited Business"
                  className="h-12 w-auto"
                />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-heading font-bold text-sm uppercase tracking-wider mb-5">
              <a href="/services/office-cleaning">Our Services</a>
            </h4>
            <ul className="space-y-3">
              {SERVICE_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-white/50 hover:text-accent text-sm font-body transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-heading font-bold text-sm uppercase tracking-wider mb-5">
              <a href="/about">Company</a>
            </h4>
            <ul className="space-y-3">
              {COMPANY_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-white/50 hover:text-accent text-sm font-body transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-heading font-bold text-sm uppercase tracking-wider mb-5">
              <a href="/contact">Contact</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-accent"></i>
                </span>
                <span className="text-white/50 text-sm font-body leading-relaxed">
                  7809 Airline Drive, Suite #307 F<br />Metairie, LA 70003
                </span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-accent"></i>
                </span>
                <a href="tel:+15048183347" className="text-white/50 hover:text-accent text-sm font-body transition-colors">
                  (504) 818-3347
                </a>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-printer-line text-accent"></i>
                </span>
                <span className="text-white/50 text-sm font-body">Fax: (504) 818-3349</span>
              </li>
            </ul>
            <div className="mt-6">
              <p className="text-white/30 text-xs font-body uppercase tracking-wider mb-3">Certifications</p>
              <ul className="space-y-1.5">
                {CERTIFICATIONS.map((cert) => (
                  <li key={cert} className="text-white/40 text-xs font-body">{cert}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-navy-border pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-xs font-body text-center md:text-left">
            &copy; {new Date().getFullYear()} OJ's Janitorial &amp; Sweeping Service, LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-white/30 text-xs font-body">
            <span>Licensed &amp; Insured</span>
            <span>|</span>
            <span>Metairie, LA 70003</span>
            <span>|</span>
            <span>GBAC Certified</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
